import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { PatientForm } from './PatientForm'
import { useCreatePatient } from '../hooks/useCreatePatient'
import { toast } from '@/hooks/use-toast'

interface NewPatientDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const NewPatientDialog: React.FC<NewPatientDialogProps> = ({ open, onOpenChange }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { mutateAsync: createPatient } = useCreatePatient()

  const handleSubmit = async (data: any) => {
    setIsLoading(true)
    try {
      await createPatient(data)
      toast({
        title: 'Success',
        description: 'Patient has been successfully registered.',
      })
      onOpenChange(false)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to register patient. Please try again.',
        variant: 'destructive',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold">Register New Patient</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          <PatientForm 
            onSubmit={handleSubmit}
            onCancel={() => onOpenChange(false)}
            isLoading={isLoading}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
